import { ImageType } from "react-images-uploading";

export function isImageType(data: any | ImageType): data is ImageType {
  if (!data) return false;
  const img = data as ImageType;
  return !!(img["data_url"] || img.dataURL);
}
